(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolongation/assets/javascripts/collections/prolongable-wagers.js') >= 0) return;  svs.modules.push('/components/numbergames/prolongation/assets/javascripts/collections/prolongable-wagers.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
svs.numbergames.prolongation.collections.ProlongableWagers = svs.numbergames.mybets_common_wager.collections.Wagers.extend({
  productId: '',
  fetchCount: 20,
  minimumFetchCount: 15,
  pagingSortKey: undefined,
  hasMoreItems: true,
  currentFetchedCount: 0,
  syndicates: [],
  oldestProlongableDraw: 0,
  isFiltered: false,
  comparator(a, b) {
    const aCompletedOn = new Date(a.get('completedOn')).getTime();
    const bCompletedOn = new Date(b.get('completedOn')).getTime();
    if (aCompletedOn === bCompletedOn) {
      return new Date(b.get('regWagerTime')) - new Date(a.get('regWagerTime'));
    }
    return bCompletedOn - aCompletedOn;
  },
  fetchAction(options) {
    drawgamesApiCaller.getPlayerFinishedWagers({
      productId: this.productId,
      pagingSortKey: this.pagingSortKey,
      count: this.fetchCount
    }).then(_ref => {
      let {
        response
      } = _ref;
      return options.success(response);
    }).catch(error => options.error(error));
  },
  initialize(models, options) {
    svs.numbergames.prolongation.logger.debug('collections.ProlongableWagers initialize', this.models);
    if (options.productId) {
      this.productId = svs.numbergames.productMapping.getProductWagersId(options.productId);
    }
    if (Array.isArray(options.syndicates)) {
      this.syndicates = options.syndicates;
    }
    if (options.oldestProlongableDraw) {
      this.oldestProlongableDraw = options.oldestProlongableDraw;
    }
  },
  parse(_ref2) {
    let {
      wagers,
      moreItems
    } = _ref2;
    svs.numbergames.prolongation.logger.debug('Parse collections.ProlongableWagers with models', wagers);
    if (!Array.isArray(wagers)) {
      svs.numbergames.prolongation.logger.warn('collections.ProlongableWagers failed to parse wagers', wagers);
      return [];
    }
    this.hasMoreItems = moreItems;
    if (wagers.length) {
      this.pagingSortKey = wagers[wagers.length - 1].pagingSortKey;
    }
    wagers = wagers.filter(wager => wager.properties.lottoSplitWagerPart !== 1 && svs.numbergames.mybets_core_wager.utils.conditionals.isProlongable(_objectSpread(_objectSpread({}, wager), {}, {
      syndicateCurrentMember: wager.isSyndicate && Boolean(_.findWhere(this.syndicates, {
        syndicateId: wager.properties.syndicateId
      }))
    })));
    if (this.oldestProlongableDraw) {
      const preFilterLength = wagers.length;
      wagers = wagers.filter(wager => parseInt(wager.currentDrawNumber, 10) >= this.oldestProlongableDraw);
      if (preFilterLength > wagers.length) {
        this.hasMoreItems = false;
        this.isFiltered = true;
      }
    }
    this.currentFetchedCount += wagers.length;
    if (this.currentFetchedCount < this.minimumFetchCount && this.hasMoreItems) {
      this.fetch();
    } else {
      this.currentFetchedCount = 0;
      this.listenToOnce(this, 'sync', () => {
        this._checkProlongationStatus();
        this.trigger('wagers:fetched');
      });
    }
    return svs.numbergames.mybets_core_wager.parsers.parseFinishedWagers(wagers, this.syndicates);
  },
  async _checkProlongationStatus() {
    await Promise.all(this.models.map(async model => {
      let existingProlong = false;
      if (svs.core.detect.feature('ft-lyckoplatsen-new-prolong')) {
        const {
          timestamp
        } = await svs.tur.prolongStorage.get({
          wagerId: model.get('wagerId'),
          productId: model.get('productId')
        });
        existingProlong = Boolean(timestamp);
      } else {
        existingProlong = svs.components.Storage.browser.get(model.get('wagerId'), 'numbergameProlong');
      }
      if (existingProlong) {
        model.set('isProlonged', true);
      }
    }));
  },
  fetch(options) {
    if (this.hasMoreItems) {
      this.constructor.__super__.fetch.call(this, _objectSpread({
        remove: false,
        parseCollection: true
      }, options));
    } else {
      svs.numbergames.prolongation.logger.debug('collections.ProlongableWagers - No more items to fetch.');
    }
  }
});

 })(window);